var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useApiClient } from './useApiClient';
import useSwr from 'swr';
/**
 * Returns the same data as First level list report, but with the option to specify downline type
 * @summary customers/{customerId}/beautyCommunityCustomers
 */
export var getCustomerBeautyCommunityCustomers = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/beautyCommunityCustomers"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerBeautyCommunityCustomersKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/beautyCommunityCustomers")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/beautyCommunityCustomers
 */
export var useGetCustomerBeautyCommunityCustomers = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBeautyCommunityCustomersKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerBeautyCommunityCustomers(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns simplified version of beautyCommunityCustomers, targeted for MV7
 * @summary customers/{customerId}/beautyCommunityCustomersSimplified
 */
export var getCustomerBeautyCommunityCustomersSimplified = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/beautyCommunityCustomersSimplified"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerBeautyCommunityCustomersSimplifiedKey = function (customerId, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/beautyCommunityCustomersSimplified")
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/beautyCommunityCustomersSimplified
 */
export var useGetCustomerBeautyCommunityCustomersSimplified = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCustomerBeautyCommunityCustomersSimplifiedKey(customerId, params) : null;
    });
    var swrFn = function () {
        return getCustomerBeautyCommunityCustomersSimplified(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides Downline summary for given customer in actual period
 * @summary customers/{customerId}/beautyRoutine/downlineSummary
 */
export var getCustomerBeautyRoutineDownlineSummary = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/beautyRoutine/downlineSummary"), method: 'get', headers: headers }, options);
};
export var getGetCustomerBeautyRoutineDownlineSummaryKey = function (customerId) {
    return ["/customers/".concat(customerId, "/beautyRoutine/downlineSummary")];
};
/**
 * @summary customers/{customerId}/beautyRoutine/downlineSummary
 */
export var useGetCustomerBeautyRoutineDownlineSummary = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBeautyRoutineDownlineSummaryKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerBeautyRoutineDownlineSummary(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides beauty routine introduction statistics for given customer in actual period
 * @summary customers/{customerId}/beautyRoutine/introductionSummary
 */
export var getCustomerBeautyRoutineIntroductionSummary = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/beautyRoutine/introductionSummary"), method: 'get', headers: headers }, options);
};
export var getGetCustomerBeautyRoutineIntroductionSummaryKey = function (customerId) {
    return ["/customers/".concat(customerId, "/beautyRoutine/introductionSummary")];
};
/**
 * @summary customers/{customerId}/beautyRoutine/introductionSummary
 */
export var useGetCustomerBeautyRoutineIntroductionSummary = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBeautyRoutineIntroductionSummaryKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerBeautyRoutineIntroductionSummary(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides a summary about downline customers using Wellness subscriptions
 * @summary customers/{customerId}/beautyRoutine/wellnessSubscriptionsSummary
 */
export var getCustomerBeautyRoutineWellnessSubscriptionsSummary = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/beautyRoutine/wellnessSubscriptionsSummary"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerBeautyRoutineWellnessSubscriptionsSummaryKey = function (customerId) {
    return ["/customers/".concat(customerId, "/beautyRoutine/wellnessSubscriptionsSummary")];
};
/**
 * @summary customers/{customerId}/beautyRoutine/wellnessSubscriptionsSummary
 */
export var useGetCustomerBeautyRoutineWellnessSubscriptionsSummary = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCustomerBeautyRoutineWellnessSubscriptionsSummaryKey(customerId) : null;
    });
    var swrFn = function () {
        return getCustomerBeautyRoutineWellnessSubscriptionsSummary(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides Downline overview for given customer in actual period - customers who bought specific products per input parameters.
 * @summary customers/{customerId}/beautyRoutine/downlineOverview
 */
export var getCustomerBeautyRoutineDownlineOverview = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/beautyRoutine/downlineOverview"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerBeautyRoutineDownlineOverviewKey = function (customerId, params) {
    return __spreadArray(["/customers/".concat(customerId, "/beautyRoutine/downlineOverview")], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/beautyRoutine/downlineOverview
 */
export var useGetCustomerBeautyRoutineDownlineOverview = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBeautyRoutineDownlineOverviewKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerBeautyRoutineDownlineOverview(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides a list of customers we want to convince to buy more/bigger products in this period, based on their purchases in the previous periods.
 * @summary customers/{customerId}/beautyRoutine/improveSalesOverview
 */
export var getCustomerBeautyRoutineImproveSalesOverview = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/beautyRoutine/improveSalesOverview"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerBeautyRoutineImproveSalesOverviewKey = function (customerId, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/beautyRoutine/improveSalesOverview")
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/beautyRoutine/improveSalesOverview
 */
export var useGetCustomerBeautyRoutineImproveSalesOverview = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCustomerBeautyRoutineImproveSalesOverviewKey(customerId, params) : null;
    });
    var swrFn = function () {
        return getCustomerBeautyRoutineImproveSalesOverview(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides a list of customer we want to introduce Beauty routine products to.
 * @summary customers/{customerId}/beautyRoutine/introduceBeautyRoutineOverview
 */
export var getCustomerBeautyRoutineIntroduceBeautyRoutineOverview = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/beautyRoutine/introduceBeautyRoutineOverview"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerBeautyRoutineIntroduceBeautyRoutineOverviewKey = function (customerId, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/beautyRoutine/introduceBeautyRoutineOverview")
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/beautyRoutine/introduceBeautyRoutineOverview
 */
export var useGetCustomerBeautyRoutineIntroduceBeautyRoutineOverview = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerBeautyRoutineIntroduceBeautyRoutineOverviewKey(customerId, params)
            : null;
    });
    var swrFn = function () {
        return getCustomerBeautyRoutineIntroduceBeautyRoutineOverview(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets a list of downline customers for a given consultant, who have subscription(s) in a given state.
 * @summary customers/{customerId}/beautyRoutine/wellnessSubscriptionsOverview
 */
export var getCustomerBeautyRoutineWellnessSubscriptionsOverview = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/beautyRoutine/wellnessSubscriptionsOverview"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerBeautyRoutineWellnessSubscriptionsOverviewKey = function (customerId, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/beautyRoutine/wellnessSubscriptionsOverview")
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/beautyRoutine/wellnessSubscriptionsOverview
 */
export var useGetCustomerBeautyRoutineWellnessSubscriptionsOverview = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerBeautyRoutineWellnessSubscriptionsOverviewKey(customerId, params)
            : null;
    });
    var swrFn = function () {
        return getCustomerBeautyRoutineWellnessSubscriptionsOverview(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides a summary about downline customers using subscriptions
 * @summary customers/{customerId}/beautyRoutine/subscriptionsSummary
 */
export var getCustomerBeautyRoutineSubscriptionsSummary = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/beautyRoutine/subscriptionsSummary"), method: 'get', headers: headers }, options);
};
export var getGetCustomerBeautyRoutineSubscriptionsSummaryKey = function (customerId) {
    return ["/customers/".concat(customerId, "/beautyRoutine/subscriptionsSummary")];
};
/**
 * @summary customers/{customerId}/beautyRoutine/subscriptionsSummary
 */
export var useGetCustomerBeautyRoutineSubscriptionsSummary = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBeautyRoutineSubscriptionsSummaryKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerBeautyRoutineSubscriptionsSummary(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets a list of downline customers for a given consultant who have subscription based on the provided Customer Subscription Status
 * @summary customers/{customerId}/beautyRoutine/personalSubscriptionsOverview
 */
export var getCustomerBeautyRoutinePersonalSubscriptionsOverview = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/beautyRoutine/personalSubscriptionsOverview"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerBeautyRoutinePersonalSubscriptionsOverviewKey = function (customerId, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/beautyRoutine/personalSubscriptionsOverview")
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/beautyRoutine/personalSubscriptionsOverview
 */
export var useGetCustomerBeautyRoutinePersonalSubscriptionsOverview = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerBeautyRoutinePersonalSubscriptionsOverviewKey(customerId, params)
            : null;
    });
    var swrFn = function () {
        return getCustomerBeautyRoutinePersonalSubscriptionsOverview(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides Consultant personal group summaries data about community members for given customer and period
(according to the parameter "numberOfPreviousPeriod" also summary data from previous periods).
 * @summary customers/{customerId}/communityMembersSummaries
 */
export var getCustomerCommunityMembersSummaries = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/communityMembersSummaries"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerCommunityMembersSummariesKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/communityMembersSummaries")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/communityMembersSummaries
 */
export var useGetCustomerCommunityMembersSummaries = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerCommunityMembersSummariesKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerCommunityMembersSummaries(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides downline summaries for given customer and period
(according to the parameter "numberOfPreviousPeriod" also summary data from previous periods).
If the period is not specified, the current period is used.
 * @summary customers/{customerId}/endCustomersSummaries
 */
export var getCustomerEndCustomersSummaries = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/endCustomersSummaries"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerEndCustomersSummariesKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/endCustomersSummaries")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/endCustomersSummaries
 */
export var useGetCustomerEndCustomersSummaries = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerEndCustomersSummariesKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerEndCustomersSummaries(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get customer upline up to the given sponsor (including sponsor and customer)
 * @summary customers/{customerId}/upline/sponsors/{sponsorId}
 */
export var getCustomerUplineSponsor = function (client, customerId, sponsorId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/upline/sponsors/").concat(sponsorId), method: 'get', headers: headers }, options);
};
export var getGetCustomerUplineSponsorKey = function (customerId, sponsorId) {
    return ["/customers/".concat(customerId, "/upline/sponsors/").concat(sponsorId)];
};
/**
 * @summary customers/{customerId}/upline/sponsors/{sponsorId}
 */
export var useGetCustomerUplineSponsor = function (customerId, sponsorId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && sponsorId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerUplineSponsorKey(customerId, sponsorId) : null); });
    var swrFn = function () {
        return getCustomerUplineSponsor(customInstance, customerId, sponsorId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Bonuses endpoint that provides customer upline up to the given sponsor (including sponsor and customer) in the given period.
 * @summary commissionPlanTypes/successPlan/customers/{customerId}/upline/sponsors
 */
export var getCommissionPlanTypesSuccessPlanCustomerUplineSponsors = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/commissionPlanTypes/successPlan/customers/".concat(customerId, "/upline/sponsors"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCommissionPlanTypesSuccessPlanCustomerUplineSponsorsKey = function (customerId, params) {
    return __spreadArray([
        "/commissionPlanTypes/successPlan/customers/".concat(customerId, "/upline/sponsors")
    ], (params ? [params] : []), true);
};
/**
 * @summary commissionPlanTypes/successPlan/customers/{customerId}/upline/sponsors
 */
export var useGetCommissionPlanTypesSuccessPlanCustomerUplineSponsors = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCommissionPlanTypesSuccessPlanCustomerUplineSponsorsKey(customerId, params)
            : null;
    });
    var swrFn = function () {
        return getCommissionPlanTypesSuccessPlanCustomerUplineSponsors(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides extended information about upline up to the given sponsor (including sponsor and customer) in the given period.
 * @summary customers/{customerId}/uplineSponsorsSp
 */
export var getCustomerUplineSponsorsSp = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/uplineSponsorsSp"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerUplineSponsorsSpKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/uplineSponsorsSp")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/uplineSponsorsSp
 */
export var useGetCustomerUplineSponsorsSp = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerUplineSponsorsSpKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerUplineSponsorsSp(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides customers details
 * @summary customers/{customerId}/contactDetailsInfo
 */
export var getCustomerContactDetailsInfo = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/contactDetailsInfo"), method: 'get', headers: headers }, options);
};
export var getGetCustomerContactDetailsInfoKey = function (customerId) {
    return ["/customers/".concat(customerId, "/contactDetailsInfo")];
};
/**
 * @summary customers/{customerId}/contactDetailsInfo
 */
export var useGetCustomerContactDetailsInfo = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerContactDetailsInfoKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerContactDetailsInfo(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Configuration for consultant info app
 * @summary applications/consultantInfo/customers/{customerId}/configuration
 */
export var getApplicationsConsultantInfoCustomerConfiguration = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/consultantInfo/customers/".concat(customerId, "/configuration"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetApplicationsConsultantInfoCustomerConfigurationKey = function (customerId) {
    return ["/applications/consultantInfo/customers/".concat(customerId, "/configuration")];
};
/**
 * @summary applications/consultantInfo/customers/{customerId}/configuration
 */
export var useGetApplicationsConsultantInfoCustomerConfiguration = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetApplicationsConsultantInfoCustomerConfigurationKey(customerId) : null;
    });
    var swrFn = function () {
        return getApplicationsConsultantInfoCustomerConfiguration(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * @summary customers/{customerId}/commissionSheetDocument/{periodId}
 */
export var getCustomerCommissionSheetDocument = function (client, customerId, periodId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/commissionSheetDocument/").concat(periodId), method: 'get', headers: headers }, options);
};
export var getGetCustomerCommissionSheetDocumentKey = function (customerId, periodId) {
    return ["/customers/".concat(customerId, "/commissionSheetDocument/").concat(periodId)];
};
/**
 * @summary customers/{customerId}/commissionSheetDocument/{periodId}
 */
export var useGetCustomerCommissionSheetDocument = function (customerId, periodId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && periodId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerCommissionSheetDocumentKey(customerId, periodId) : null); });
    var swrFn = function () {
        return getCustomerCommissionSheetDocument(customInstance, customerId, periodId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides personal group list
 * @summary customers/{customerId}/personalGroupListing/personalGroup/{commissionPlan}
 */
export var getCustomerPersonalGroupListingPersonalGroup = function (client, customerId, commissionPlan, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/personalGroupListing/personalGroup/").concat(commissionPlan),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerPersonalGroupListingPersonalGroupKey = function (customerId, commissionPlan, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/personalGroupListing/personalGroup/").concat(commissionPlan)
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/personalGroupListing/personalGroup/{commissionPlan}
 */
export var useGetCustomerPersonalGroupListingPersonalGroup = function (customerId, commissionPlan, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && commissionPlan);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerPersonalGroupListingPersonalGroupKey(customerId, commissionPlan, params)
            : null;
    });
    var swrFn = function () {
        return getCustomerPersonalGroupListingPersonalGroup(customInstance, customerId, commissionPlan, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides personal group contact info
 * @summary customers/{customerId}/personalGroupListing/personalGroup/{commissionPlan}/contactInfo
 */
export var getCustomerApplicationsMobileOfficePersonalGroupListingPersonalGroupContact = function (client, customerId, commissionPlan, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/personalGroupListing/personalGroup/").concat(commissionPlan, "/contactInfo"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerApplicationsMobileOfficePersonalGroupListingPersonalGroupContactKey = function (customerId, commissionPlan) {
    return [
        "/customers/".concat(customerId, "/personalGroupListing/personalGroup/").concat(commissionPlan, "/contactInfo"),
    ];
};
/**
 * @summary customers/{customerId}/personalGroupListing/personalGroup/{commissionPlan}/contactInfo
 */
export var useGetCustomerApplicationsMobileOfficePersonalGroupListingPersonalGroupContact = function (customerId, commissionPlan, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && commissionPlan);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerApplicationsMobileOfficePersonalGroupListingPersonalGroupContactKey(customerId, commissionPlan)
            : null;
    });
    var swrFn = function () {
        return getCustomerApplicationsMobileOfficePersonalGroupListingPersonalGroupContact(customInstance, customerId, commissionPlan, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides filtered personal group list by welcome program step  for mobile office
 * @summary customers/{customerId}/personalGroupListing/welcomeProgramProgress/{welcomeProgramStep}
 */
export var getCustomerApplicationsMobileOfficePersonalGroupListingWelcomeProgramPrgs = function (client, customerId, welcomeProgramStep, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/personalGroupListing/welcomeProgramProgress/").concat(welcomeProgramStep),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerApplicationsMobileOfficePersonalGroupListingWelcomeProgramPrgsKey = function (customerId, welcomeProgramStep, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/personalGroupListing/welcomeProgramProgress/").concat(welcomeProgramStep)
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/personalGroupListing/welcomeProgramProgress/{welcomeProgramStep}
 */
export var useGetCustomerApplicationsMobileOfficePersonalGroupListingWelcomeProgramPrgs = function (customerId, welcomeProgramStep, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && welcomeProgramStep);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerApplicationsMobileOfficePersonalGroupListingWelcomeProgramPrgsKey(customerId, welcomeProgramStep, params)
            : null;
    });
    var swrFn = function () {
        return getCustomerApplicationsMobileOfficePersonalGroupListingWelcomeProgramPrgs(customInstance, customerId, welcomeProgramStep, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides list of partners participating in selected welcome program step for each partner for mobile office
 * @summary customers/{customerId}/personalGroupListing/welcomeProgram/{welcomeProgramStep}
 */
export var getCustomerApplicationsMobileOfficePersonalGroupListingWelcomePrgStep = function (client, customerId, welcomeProgramStep, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/personalGroupListing/welcomeProgram/").concat(welcomeProgramStep),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerApplicationsMobileOfficePersonalGroupListingWelcomePrgStepKey = function (customerId, welcomeProgramStep, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/personalGroupListing/welcomeProgram/").concat(welcomeProgramStep)
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/personalGroupListing/welcomeProgram/{welcomeProgramStep}
 */
export var useGetCustomerApplicationsMobileOfficePersonalGroupListingWelcomePrgStep = function (customerId, welcomeProgramStep, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && welcomeProgramStep);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerApplicationsMobileOfficePersonalGroupListingWelcomePrgStepKey(customerId, welcomeProgramStep, params)
            : null;
    });
    var swrFn = function () {
        return getCustomerApplicationsMobileOfficePersonalGroupListingWelcomePrgStep(customInstance, customerId, welcomeProgramStep, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides list of partners participating in selected gamified welcome program step for each partner for mobile office
 * @summary customers/{customerId}/personalGroupListing/gamifiedWelcomeProgram/{welcomeProgramStep}
 */
export var getCustomerApplicationsMobileOfficeGamifPersonalGroupListingWelcomePrgStep = function (client, customerId, welcomeProgramStep, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/personalGroupListing/gamifiedWelcomeProgram/").concat(welcomeProgramStep),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerApplicationsMobileOfficeGamifPersonalGroupListingWelcomePrgStepKey = function (customerId, welcomeProgramStep, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/personalGroupListing/gamifiedWelcomeProgram/").concat(welcomeProgramStep)
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/personalGroupListing/gamifiedWelcomeProgram/{welcomeProgramStep}
 */
export var useGetCustomerApplicationsMobileOfficeGamifPersonalGroupListingWelcomePrgStep = function (customerId, welcomeProgramStep, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && welcomeProgramStep);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerApplicationsMobileOfficeGamifPersonalGroupListingWelcomePrgStepKey(customerId, welcomeProgramStep, params)
            : null;
    });
    var swrFn = function () {
        return getCustomerApplicationsMobileOfficeGamifPersonalGroupListingWelcomePrgStep(customInstance, customerId, welcomeProgramStep, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets customers split-outs for a given period
 * @summary customers/{customerId}/splitOuts/{periodId}
 */
export var getCustomerSplitOut = function (client, customerId, periodId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/splitOuts/").concat(periodId), method: 'get', headers: headers }, options);
};
export var getGetCustomerSplitOutKey = function (customerId, periodId) {
    return ["/customers/".concat(customerId, "/splitOuts/").concat(periodId)];
};
/**
 * @summary customers/{customerId}/splitOuts/{periodId}
 */
export var useGetCustomerSplitOut = function (customerId, periodId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && periodId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerSplitOutKey(customerId, periodId) : null); });
    var swrFn = function () {
        return getCustomerSplitOut(customInstance, customerId, periodId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides customers VIP list, according to filter
 * @summary customers/{customerId}/myBusiness/vipCustomers/{customerFilter}
 */
export var getCustomerMyBusinessVipCustomer = function (client, customerId, customerFilter, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/myBusiness/vipCustomers/").concat(customerFilter),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerMyBusinessVipCustomerKey = function (customerId, customerFilter, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/myBusiness/vipCustomers/").concat(customerFilter)
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/myBusiness/vipCustomers/{customerFilter}
 */
export var useGetCustomerMyBusinessVipCustomer = function (customerId, customerFilter, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && customerFilter);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerMyBusinessVipCustomerKey(customerId, customerFilter, params)
            : null;
    });
    var swrFn = function () {
        return getCustomerMyBusinessVipCustomer(customInstance, customerId, customerFilter, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides new activity report for customer in specified period according to selected activity type.
 * @summary customers/{customerId}/directReports/bcmNewActivity/periods/{periodId}
 */
export var getCustomerDirectReportsBcmNewActivityPeriod = function (client, customerId, periodId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/directReports/bcmNewActivity/periods/").concat(periodId),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerDirectReportsBcmNewActivityPeriodKey = function (customerId, periodId, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/directReports/bcmNewActivity/periods/").concat(periodId)
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/directReports/bcmNewActivity/periods/{periodId}
 */
export var useGetCustomerDirectReportsBcmNewActivityPeriod = function (customerId, periodId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && periodId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerDirectReportsBcmNewActivityPeriodKey(customerId, periodId, params)
            : null;
    });
    var swrFn = function () {
        return getCustomerDirectReportsBcmNewActivityPeriod(customInstance, customerId, periodId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides KPIs (current status, target status) for specified downline
 * @summary customers/{customerId}/myBusiness/kpidownlinemm/{downlineType}/{customerFilter}/{customerCategoryFilter}
 */
export var getCustomerMyBusinessKpidownlinemm = function (client, customerId, downlineType, customerFilter, customerCategoryFilter, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/myBusiness/kpidownlinemm/").concat(downlineType, "/").concat(customerFilter, "/").concat(customerCategoryFilter),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerMyBusinessKpidownlinemmKey = function (customerId, downlineType, customerFilter, customerCategoryFilter, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/myBusiness/kpidownlinemm/").concat(downlineType, "/").concat(customerFilter, "/").concat(customerCategoryFilter)
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/myBusiness/kpidownlinemm/{downlineType}/{customerFilter}/{customerCategoryFilter}
 */
export var useGetCustomerMyBusinessKpidownlinemm = function (customerId, downlineType, customerFilter, customerCategoryFilter, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false &&
        !!(customerId && downlineType && customerFilter && customerCategoryFilter);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerMyBusinessKpidownlinemmKey(customerId, downlineType, customerFilter, customerCategoryFilter, params)
            : null;
    });
    var swrFn = function () {
        return getCustomerMyBusinessKpidownlinemm(customInstance, customerId, downlineType, customerFilter, customerCategoryFilter, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides configuration for Mobile Office
 * @deprecated
 * @summary configuration
 */
export var getConfigurationDeprecated = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/configuration", method: 'get', headers: headers }, options);
};
export var getGetConfigurationDeprecatedKey = function () { return ["/configuration"]; };
/**
 * @deprecated
 * @summary configuration
 */
export var useGetConfigurationDeprecated = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetConfigurationDeprecatedKey() : null); });
    var swrFn = function () {
        return getConfigurationDeprecated(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get reward steps configuration for VIP customers
 * @summary myBusiness/vipLoyaltyRewardsSteps
 */
export var getMyBusinessVipLoyaltyRewardsSteps = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/myBusiness/vipLoyaltyRewardsSteps", method: 'get', headers: headers }, options);
};
export var getGetMyBusinessVipLoyaltyRewardsStepsKey = function () {
    return ["/myBusiness/vipLoyaltyRewardsSteps"];
};
/**
 * @summary myBusiness/vipLoyaltyRewardsSteps
 */
export var useGetMyBusinessVipLoyaltyRewardsSteps = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetMyBusinessVipLoyaltyRewardsStepsKey() : null); });
    var swrFn = function () {
        return getMyBusinessVipLoyaltyRewardsSteps(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets My business configuration
 * @summary myBusiness/customers/{customerId}/configuration
 */
export var getMyBusinessCustomerConfiguration = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/myBusiness/customers/".concat(customerId, "/configuration"), method: 'get', headers: headers }, options);
};
export var getGetMyBusinessCustomerConfigurationKey = function (customerId) {
    return ["/myBusiness/customers/".concat(customerId, "/configuration")];
};
/**
 * @summary myBusiness/customers/{customerId}/configuration
 */
export var useGetMyBusinessCustomerConfiguration = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetMyBusinessCustomerConfigurationKey(customerId) : null); });
    var swrFn = function () {
        return getMyBusinessCustomerConfiguration(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * End customers summary
 * @summary customers/{customerId}/myEndCustomersSummary
 */
export var getCustomerMyEndCustomersSummary = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/myEndCustomersSummary"), method: 'get', headers: headers }, options);
};
export var getGetCustomerMyEndCustomersSummaryKey = function (customerId) {
    return ["/customers/".concat(customerId, "/myEndCustomersSummary")];
};
/**
 * @summary customers/{customerId}/myEndCustomersSummary
 */
export var useGetCustomerMyEndCustomersSummary = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerMyEndCustomersSummaryKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerMyEndCustomersSummary(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides onboarding program list, according to filter
 * @summary customers/{customerId}/myBusiness/stepsToSuccess
 */
export var getCustomerMyBusinessStepsToSuccess = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/myBusiness/stepsToSuccess"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerMyBusinessStepsToSuccessKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/myBusiness/stepsToSuccess")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/myBusiness/stepsToSuccess
 */
export var useGetCustomerMyBusinessStepsToSuccess = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerMyBusinessStepsToSuccessKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerMyBusinessStepsToSuccess(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * First level summary of onboarding.
 * @summary customers/{customerId}/applications/mobileOffice/firstLevelSummary/onboarding
 */
export var getCustomerApplicationsMobileOfficeFirstLevelSummaryOnboarding = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/applications/mobileOffice/firstLevelSummary/onboarding"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerApplicationsMobileOfficeFirstLevelSummaryOnboardingKey = function (customerId) { return ["/customers/".concat(customerId, "/applications/mobileOffice/firstLevelSummary/onboarding")]; };
/**
 * @summary customers/{customerId}/applications/mobileOffice/firstLevelSummary/onboarding
 */
export var useGetCustomerApplicationsMobileOfficeFirstLevelSummaryOnboarding = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerApplicationsMobileOfficeFirstLevelSummaryOnboardingKey(customerId)
            : null;
    });
    var swrFn = function () {
        return getCustomerApplicationsMobileOfficeFirstLevelSummaryOnboarding(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Onboarding summary statistics.
 * @summary customers/{customerId}/onboardingSummary
 */
export var getCustomerOnboardingSummary = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/onboardingSummary"), method: 'get', headers: headers }, options);
};
export var getGetCustomerOnboardingSummaryKey = function (customerId) {
    return ["/customers/".concat(customerId, "/onboardingSummary")];
};
/**
 * @summary customers/{customerId}/onboardingSummary
 */
export var useGetCustomerOnboardingSummary = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerOnboardingSummaryKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerOnboardingSummary(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets perfect start welcome page redirect status for given customer.
 * @summary applications/stepsToSuccess/customers/{customerId}/redirectLink
 */
export var getApplicationsStepsToSuccessCustomerRedirectLink = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/stepsToSuccess/customers/".concat(customerId, "/redirectLink"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetApplicationsStepsToSuccessCustomerRedirectLinkKey = function (customerId) {
    return ["/applications/stepsToSuccess/customers/".concat(customerId, "/redirectLink")];
};
/**
 * @summary applications/stepsToSuccess/customers/{customerId}/redirectLink
 */
export var useGetApplicationsStepsToSuccessCustomerRedirectLink = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetApplicationsStepsToSuccessCustomerRedirectLinkKey(customerId) : null;
    });
    var swrFn = function () {
        return getApplicationsStepsToSuccessCustomerRedirectLink(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides bp ranges for discounts
 * @summary personalGroupListing/discountRateBpRanges
 */
export var getPersonalGroupListingDiscountRateBpRanges = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalGroupListing/discountRateBpRanges", method: 'get', headers: headers }, options);
};
export var getGetPersonalGroupListingDiscountRateBpRangesKey = function () {
    return ["/personalGroupListing/discountRateBpRanges"];
};
/**
 * @summary personalGroupListing/discountRateBpRanges
 */
export var useGetPersonalGroupListingDiscountRateBpRanges = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPersonalGroupListingDiscountRateBpRangesKey() : null); });
    var swrFn = function () {
        return getPersonalGroupListingDiscountRateBpRanges(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides starters list, according to filter
 * @summary customers/{customerId}/starters
 */
export var getCustomerStarters = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/starters"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerStartersKey = function (customerId, params) {
    return __spreadArray(["/customers/".concat(customerId, "/starters")], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/starters
 */
export var useGetCustomerStarters = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerStartersKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerStarters(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides customer upline in given period and return Sponsor, Leader, Personal group leader and Director.
 * @summary commissionPlans/successPlan/customers/{customerId}/leaders
 */
export var getCommissionPlansSuccessPlanCustomerLeaders = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/commissionPlans/successPlan/customers/".concat(customerId, "/leaders"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCommissionPlansSuccessPlanCustomerLeadersKey = function (customerId, params) {
    return __spreadArray([
        "/commissionPlans/successPlan/customers/".concat(customerId, "/leaders")
    ], (params ? [params] : []), true);
};
/**
 * @summary commissionPlans/successPlan/customers/{customerId}/leaders
 */
export var useGetCommissionPlansSuccessPlanCustomerLeaders = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCommissionPlansSuccessPlanCustomerLeadersKey(customerId, params) : null;
    });
    var swrFn = function () {
        return getCommissionPlansSuccessPlanCustomerLeaders(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides seminar status report for given customer and period.
 * @summary commissionPlans/successPlan/customers/{customerId}/reports/seminarStatusReport
 */
export var getCommissionPlansSuccessPlanCustomerReportsSeminarStatusReport = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/commissionPlans/successPlan/customers/".concat(customerId, "/reports/seminarStatusReport"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCommissionPlansSuccessPlanCustomerReportsSeminarStatusReportKey = function (customerId, params) {
    return __spreadArray([
        "/commissionPlans/successPlan/customers/".concat(customerId, "/reports/seminarStatusReport")
    ], (params ? [params] : []), true);
};
/**
 * @summary commissionPlans/successPlan/customers/{customerId}/reports/seminarStatusReport
 */
export var useGetCommissionPlansSuccessPlanCustomerReportsSeminarStatusReport = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCommissionPlansSuccessPlanCustomerReportsSeminarStatusReportKey(customerId, params)
            : null;
    });
    var swrFn = function () {
        return getCommissionPlansSuccessPlanCustomerReportsSeminarStatusReport(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets history of personal group activity
 * @summary summaryHistory/customers/{customerId}/downlinetypes/{downlineType}
 */
export var getSummaryHistoryCustomerDownlinetype = function (client, customerId, downlineType, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/summaryHistory/customers/".concat(customerId, "/downlinetypes/").concat(downlineType),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetSummaryHistoryCustomerDownlinetypeKey = function (customerId, downlineType, params) {
    return __spreadArray([
        "/summaryHistory/customers/".concat(customerId, "/downlinetypes/").concat(downlineType)
    ], (params ? [params] : []), true);
};
/**
 * @summary summaryHistory/customers/{customerId}/downlinetypes/{downlineType}
 */
export var useGetSummaryHistoryCustomerDownlinetype = function (customerId, downlineType, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && downlineType);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetSummaryHistoryCustomerDownlinetypeKey(customerId, downlineType, params)
            : null;
    });
    var swrFn = function () {
        return getSummaryHistoryCustomerDownlinetype(customInstance, customerId, downlineType, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * @summary test/ping
 */
export var getTestPing = function (client, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/test/ping", method: 'get' }, options);
};
export var getGetTestPingKey = function () { return ["/test/ping"]; };
/**
 * @summary test/ping
 */
export var useGetTestPing = function (options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTestPingKey() : null); });
    var swrFn = function () { return getTestPing(customInstance, requestOptions).then(function (d) { return d.data; }); };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};

